import { render, staticRenderFns } from "./daughterCardManageDetail.vue?vue&type=template&id=abce392e&scoped=true&"
import script from "./daughterCardManageDetail.vue?vue&type=script&lang=js&"
export * from "./daughterCardManageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abce392e",
  null
  
)

export default component.exports